import React from 'react'
import {Grid, Row, Col} from 'react-flexbox-grid'
import {Link} from 'react-router'

import {Menu} from 'antd'

import {UserStorage} from 'storage'
import {RequireAuth} from 'bundle/auth'

import {Account} from './account'
import {Tokens} from './Tokens.jsx'
import {CreateToken} from './CreateToken.jsx'
import {Sessions} from './Sessions.jsx'

import {NotFound} from 'pages/NotFound.jsx'

export {Account, Tokens, Sessions}

export class User extends React.Component {
   static get propTypes() {
      return {
         children: React.PropTypes.element.isRequired
      }
   }

   render() {
      const {children, ...props} = this.props

      return (
         <RequireAuth {...props}>
            <Grid className="bundle user">
               <Row>
                  <Col md={3} className="sidebar">
                     <Menu
                        mode="inline"
                        defaultOpenKeys={['auth']}
                        selectedKeys={_.map(this.props.routes, 'path')}
                     >
                        <Menu.ItemGroup title="User Account" key="account">
                           <Menu.Item key="account">
                              <Link to="/user/account">Settings</Link>
                           </Menu.Item>
                        </Menu.ItemGroup>

                        <Menu.ItemGroup title="Authentication" key="auth">
                           <Menu.Item key="auth/sessions">
                              <Link to="/user/auth/sessions">Sessions</Link>
                           </Menu.Item>
                           <Menu.Item key="auth/tokens">
                              <Link to="/user/auth/tokens">API Tokens</Link>
                           </Menu.Item>

                           <Menu.Item key="auth/new-token">
                              <Link to="/user/auth/new-token">Create New Token</Link>
                           </Menu.Item>
                        </Menu.ItemGroup>
                     </Menu>
                  </Col>

                  <Col md={9} className="main">
                     <Row>
                        <Col xs={12}>
                           <UserStorage>{this.props.children}</UserStorage>
                        </Col>
                     </Row>
                  </Col>
               </Row>
            </Grid>
         </RequireAuth>
      )
   }
}

User.childRoutes = [
   {
      path:        'account',
      component:   Account,
      childRoutes: Account.childRoutes
   },
   {
      path:        'auth/tokens',
      component:   Tokens,
      childRoutes: Tokens.childRoutes
   },
   {
      path:        'auth/new-token',
      component:   CreateToken,
      childRoutes: CreateToken.childRoutes
   },
   {
      path:        'auth/sessions',
      component:   Sessions,
      childRoutes: Sessions.childRoutes
   },
   {
      path:      '*',
      component: () => <NotFound useGrid={false} />
   }
]



// WEBPACK FOOTER //
// lib/bundle/user/index.js